import axios from 'axios';
import { createHmac } from './hmac-auth';

export const postRequest = async (
  url: string,
  body: any,
  useSignature: boolean
) =>
  await axios.post(url, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      ...(useSignature
        ? { 'x-airflow-connectors-signature': createHmac(body) }
        : {})
    }
  });

export const getRequest = async (
  url: string,
  params: any,
  useSignature: boolean
) =>
  await axios.get(url, {
    withCredentials: true,
    params: { ...(params ? params : {}) },
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      ...(params && useSignature
        ? { 'x-airflow-connectors-signature': createHmac(params) }
        : {})
    }
  });
